// extracted by mini-css-extract-plugin
export default {"cls1":"QuestionStyles-cls1_FJH","cls2":"QuestionStyles-cls2_Dep QuestionStyles-cls1_FJH","multiColumn":"QuestionStyles-multiColumn_OT4"};